import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FiUser, FiMail, FiPhone, FiMapPin, FiSend, FiCheckCircle } from 'react-icons/fi';

const RegistrationForm = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    city: '',
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [submitError, setSubmitError] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitSuccess(false);
    setSubmitError(false);

    try {
      const gForm = new FormData();
      // تأكد من أن IDs هذه تتطابق مع IDs حقولك في Google Form
      gForm.append("entry.1763365559", formData.fullName);
      gForm.append("entry.1213968077", formData.email);
      gForm.append("entry.1214125593", formData.phone);
      gForm.append("entry.4567890123", formData.city);
      // إذا كان لديك حقل experience في المستقبل:
      // gForm.append("entry.5678901234", formData.experience);

      const response = await fetch(
        "https://docs.google.com/forms/d/e/1FAIpQLSdizC8FbyhIr-5gUh1EixBcRnugfHIvZ5ESbFrMp-TC1EuoMg/formResponse",
        {
          method: "POST",
          mode: "no-cors",
          body: gForm,
        }
      );

      // مع mode: "no-cors" لا يمكننا قراءة الرد، لذا نعتبره ناجحاً
      setSubmitSuccess(true);
      
      // Reset form
      setFormData({
        fullName: '',
        email: '',
        phone: '',
        city: '',
      });
      
      // إخفاء رسالة النجاح بعد 5 ثواني
      setTimeout(() => setSubmitSuccess(false), 15000);
      
    } catch (error) {
      console.error('Form submission error:', error);
      setSubmitError(true);
      setTimeout(() => setSubmitError(false), 5000);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="max-w-2xl mx-auto"
    >
      <form onSubmit={handleSubmit} className="space-y-6">
        {/* Form Fields */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {[
            { name: 'fullName', icon: FiUser, label: 'Full Name', type: 'text' },
            { name: 'email', icon: FiMail, label: 'Email', type: 'email' },
            { name: 'phone', icon: FiPhone, label: 'Phone', type: 'tel' },
            { name: 'city', icon: FiMapPin, label: 'City', type: 'text' }
          ].map((field) => (
            <div key={field.name} className="relative">
              <label className="block text-gray-300 text-sm mb-2">
                {field.label}
              </label>
              <div className="relative">
                <field.icon className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
                <input
                  type={field.type}
                  name={field.name}
                  value={formData[field.name]}
                  onChange={handleChange}
                  required
                  className="w-full pl-10 pr-4 py-3 bg-white/5 border border-gray-700 rounded-lg text-white focus:outline-none focus:border-blue-500 transition-colors"
                  placeholder={`Enter your ${field.label.toLowerCase()}`}
                />
              </div>
            </div>
          ))}
        </div>

        {/* Submit Button */}
        <motion.button
          type="submit"
          disabled={isSubmitting}
          className="w-full py-4 bg-gradient-to-r from-blue-600 to-cyan-500 text-white font-semibold rounded-lg hover:opacity-90 transition-opacity flex items-center justify-center space-x-2 disabled:opacity-50"
          whileHover={{ scale: 1.01 }}
          whileTap={{ scale: 0.99 }}
        >
          {isSubmitting ? (
            <>
              <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
              <span>Processing...</span>
            </>
          ) : (
            <>
              <FiSend className="w-5 h-5" />
              <span>Submit </span>
            </>
          )}
        </motion.button>

        {/* Success Message */}
        {submitSuccess && (
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            className="p-4 bg-green-500/10 border border-green-500/30 rounded-lg flex items-center space-x-3"
          >
            <FiCheckCircle className="w-5 h-5 text-green-400 flex-shrink-0" />
            <div>
              <p className="text-green-300 font-medium">registration submitted successfully!</p>
              <p className="text-green-300/70 text-sm">We'll contact you soon.</p>
            </div>
          </motion.div>
        )}

        {/* Error Message */}
        {submitError && (
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            className="p-4 bg-red-500/10 border border-red-500/30 rounded-lg"
          >
            <p className="text-red-300">There was an error submitting your registration. Please try again.</p>
          </motion.div>
        )}

        {/* Privacy Note */}
        <p className="text-center text-gray-400 text-sm">
          Your information is secure and confidential
        </p>
      </form>
    </motion.div>
  );
};

export default RegistrationForm;
